// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__Km_x1","buttons":"PendingPaymentAlert_buttons__2rCSK"};